import React from "react";
import moment from "moment";

import { roles, VACATION_REQUEST_STATUS_ID, VACATION_REQUEST_STATUS_LABELS } from "../../../configs/constants";
import { MODAL_TYPE_VACATIONS } from "../utils/constants";
import { get } from "../utils/utils";

const checkIfManage = ({ request, roleId, userId }) => {
  const statusId = get(["status", "id"], request);
  const requestRoleId = get(["user_role_id"], request);
  const isRejected = statusId === VACATION_REQUEST_STATUS_ID.REJECTED;
  const isHerSuperior = requestRoleId > roleId;
  const isAdmin = roleId === roles.ADMIN;

  if (userId === request.user_id) return false;
  return !isRejected && (isHerSuperior || isAdmin);
};

const UserVacationRow = ({ userId, request, manangeButtonPressed, manageDeleteVacation, roleId }) => {
  return (
    <tr className="hover:bg-gray-100 cursor-pointer" key={request._id}>
      <td className="p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900">
        {request.user_fullname}
      </td>
      <td className="p-6 whitespace-no-wrap border-b border-gray-200 leading-5 text-gray-500">
        {request.status.id === 1 && (
          <span className="px-3 py-1 text-sm leading-5 font-medium rounded-full bg-gray-200 text-gray-800">
            En attente de Validation
          </span>
        )}
        {request.status.id === 2 && <span className="font-bold text-green-500">Validé</span>}
        {(request.status.id === 4 || request.status.id === 3) && (
          <span className="font-bold text-red-500">{request.status.id === 4 ? "Supprimé" : "Refusé"}</span>
        )}
      </td>
      <td className="p-6 whitespace-no-wrap border-b border-gray-200 leading-5 text-gray-900">
        {moment(request.request_date).format("DD/MM/YYYY")}
      </td>
      <td className="p-6 whitespace-no-wrap border-b border-gray-200 leading-5 text-gray-900">
        {request.type && request.type.label}
      </td>
      <td className="p-6 whitespace-no-wrap border-b border-gray-200 leading-5 text-gray-900">
        {moment(request.start_date).format("DD/MM/YYYY") + " - " + moment(request.end_date).format("DD/MM/YYYY")}
      </td>
      <td className="p-6 whitespace-no-wrap border-b border-gray-200 leading-5 text-gray-900">{request.duration}</td>
      <td className="p-6 whitespace-no-wrap border-b border-gray-200 leading-5 text-gray-900">
        {request.attachements.length < 1 ? (
          "Non"
        ) : (
          <a
            className="cursor-pointer underline font-bold text-orange-400"
            onClick={() => {
              manangeButtonPressed({ request, modalType: MODAL_TYPE_VACATIONS.ATTACHMENTS });
            }}
          >
            Voir
          </a>
        )}
      </td>
      <td className="p-6 whitespace-no-wrap border-b border-gray-200 leading-5 text-gray-900">
        {request.status.label === VACATION_REQUEST_STATUS_LABELS.PENDING
          ? "Non Traité"
          : moment(request.status.updated_at).format("DD/MM/YYYY")}
      </td>
      <td className="p-6 whitespace-no-wrap border-b border-gray-200 leading-5 text-gray-900">
        {checkIfManage({ request, roleId, userId }) ? (
          <span
            className="cursor-pointer px-4 py-2 leading-5 rounded-full bg-green-400 text-white"
            onClick={() => manangeButtonPressed({ request, modalType: MODAL_TYPE_VACATIONS.VALIDATE })}
          >
            Gérer
          </span>
        ) : (
          <a
            className="cursor-pointer underline font-bold text-orange-400"
            onClick={() => {
              manangeButtonPressed({ request, modalType: MODAL_TYPE_VACATIONS.QUICKLOOK });
            }}
          >
            Voir
          </a>
        )}
        {request.status.id === 1 && (
          <a
            className="ml-2 cursor-pointer px-4 py-2 rounded-full bg-red-400 text-white"
            onClick={() => manageDeleteVacation(request._id)}
          >
            Supprimer
          </a>
        )}
      </td>
    </tr>
  );
};

export default UserVacationRow;



// WEBPACK FOOTER //
// src/modules/presence/components/UserVacationRow.js